<template>
  <div>
    <div v-for="(item, key) in quickBars" :key="key" class="link-item brush-item">
      <div class="link-item-name" @click="goHelpCenter(item)">
        <div class="link-item-image">
          <img :src="item.image" alt="">
        </div>
        <div class="link-item-text">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQuickBar } from '@/api/brand'
import { rollStart } from '@/utils/roll'
import { handleTokenUrl } from '@/utils/tool'

export default {
  props: {
    mode: {
      type: String,
      default: 'left' // left
    }
  },
  data() {
    return {
      show: true,
      quickBars: [],
      hoverColor: [
        'service',
        'app',
        'net',
        'toff',
        'chat'
      ],
      showIframe: false,
      iframeSrc: ''
    }
  },
  watch: {
    quickBars() {
      const isProd = process.env.VUE_APP_ENV === 'production'
      const licenseId = isProd ? 16229799 : 18592269
      if (this.quickBars.length) {
        this.checkTokenUrl(licenseId)
      }
    }
  },
  created() {
    getQuickBar().then(response => {
      this.quickBars = response.data.data.filter((item) => {
        return item.type === 'web'
      })
    })
  },
  mounted() {
    const isProd = process.env.VUE_APP_ENV === 'production'
    const licenseId = isProd ? 16229799 : 18592269
    window.__lc = window.__lc || {}
    window.__lc.license = licenseId

    ;(function(n, t, c) {
      function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: '2.0', on: function() { i(['on', c.call(arguments)]) }, once: function() { i(['once', c.call(arguments)]) }, off: function() { i(['off', c.call(arguments)]) }, get: function() { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(['get', c.call(arguments)]) }, call: function() { i(['call', c.call(arguments)]) }, init: function() {
        var n = t.createElement('script'); n.async = !0; n.type = 'text/javascript'; n.src = 'https://cdn.livechatinc.com/tracking.js'; t.head.appendChild(n)
      } }; !n.__lc.asyncInit && e.init(); n.LiveChatWidget = n.LiveChatWidget || e
    }(window, document, [].slice))

    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'minimized':
          LiveChatWidget.call('hide')
          break
        case 'hidden':
          break
      }
    }

    // Wait for LiveChatWidget to be ready before setting up events and hiding
    LiveChatWidget.on('ready', () => {
      LiveChatWidget.on('visibility_changed', onVisibilityChanged)
      LiveChatWidget.call('hide')
    })
  },
  methods: {
    // goHelpCenter2(item) {
    //   let formattedLink = item.url
    //   if (!this.$store.getters.token) {
    //     const url = new URL(formattedLink)
    //     formattedLink = url.origin + url.pathname
    //   } else {
    //     const username = this.$store.state.user.memberInfo.username
    //     const email = this.$store.state.user.memberInfo.email
    //     // Encode the username and email to ensure they are URL-safe
    //     const encodedUsername = encodeURIComponent(username)
    //     const encodedEmail = encodeURIComponent(email)

    //     const kycStatusMap = {
    //       0: 'KYC_NONE',
    //       1: 'KYC_PASS',
    //       2: 'KYC_PROGRESS'
    //     }
    //     const isPassKYC = this.$store.state.user.memberInfo.is_pass_KYC
    //     const isPassKYCText = kycStatusMap[isPassKYC]

    //     const firstDepositAmount = this.$store.state.user.memberInfo.first_deposit_amount
    //     const secondDepositAmount = this.$store.state.user.memberInfo.second_deposit_amount
    //     const thirdDepositAmount = this.$store.state.user.memberInfo.third_deposit_amount

    //     formattedLink = formattedLink
    //       .replace('{NAME}', encodedUsername)
    //       .replace('{EMAIL}', encodedEmail)
    //       .replace('&amp;', '&') // Replace '&amp;' with '&'
    //       .replace('{K}', isPassKYCText)
    //       .replace('{D}', `${firstDepositAmount},${secondDepositAmount},${thirdDepositAmount}`)
    //   }
    //   window.open(formattedLink, item.open_type)
    //   // this.iframeSrc = formattedLink
    //   // console.log(formattedLink)
    //   // this.showIframe = true
    // },
    setLiveChatWidget(username, email) {
      LiveChatWidget.call('set_customer_name', username)
      LiveChatWidget.call('set_customer_email', email)
      LiveChatWidget.call('maximize')
    },
    goHelpCenter(item) {
      const isGuest = !this.$store.getters.token
      let formattedLink = item.url

      if (isGuest) {
        if (item.open_type === '_iframe') {
          this.setLiveChatWidget('guest', 'guest@katsuwin.io')
        } else {
          const url = new URL(formattedLink)
          formattedLink = `${url.origin}${url.pathname}`
          window.open(formattedLink, item.open_type)
        }
      } else {
        const { username, email, is_pass_KYC, first_deposit_amount, second_deposit_amount, third_deposit_amount, birthday, vip_last_updated_at, last_withdrawal_amount, last_withdrawal_updated_at } = this.$store.state.user.memberInfo
        const kycStatusMap = {
          0: 'KYC_NONE',
          1: 'KYC_PASS',
          2: 'KYC_PROGRESS'
        }
        const isPassKYCText = kycStatusMap[is_pass_KYC]

        if (item.open_type === '_iframe') {
          const vipName = this.$store.state.user.vipInfo.currentVipName
          LiveChatWidget.call('set_session_variables', {
            kyc: isPassKYCText,
            dep1: first_deposit_amount,
            dep2: second_deposit_amount,
            dep3: third_deposit_amount,
            vip: vipName,
            birthday: birthday,
            vip_last_updated_at: vip_last_updated_at === 0 ? 0 : this.$options.filters.dateFormat(vip_last_updated_at),
            last_withdrawal_amount: last_withdrawal_amount,
            last_withdrawal_updated_at: last_withdrawal_updated_at === 0 ? 0 : this.$options.filters.dateFormat(last_withdrawal_updated_at)
          })

          this.setLiveChatWidget(username, email)
        } else {
          const encodedUsername = encodeURIComponent(username)
          const encodedEmail = encodeURIComponent(email)

          formattedLink = formattedLink
            .replace('{NAME}', encodedUsername)
            .replace('{EMAIL}', encodedEmail)
            .replace('&amp;', '&')
            .replace('{K}', is_pass_KYC)
            .replace('{D}', `${first_deposit_amount},${second_deposit_amount},${third_deposit_amount}`)
          window.open(formattedLink, item.open_type)
        }
      }
    },
    getChatSrc() {
      let charSrc = this.$store.getters.urlInfo.websocketChatUrl
      if (charSrc && this.$store.getters.token) {
        charSrc += '&token=' + this.$store.getters.token
      }
      return charSrc
    },
    rollLaunch() {
      rollStart()
    },
    checkTokenUrl(licenseId) {
      let url = new URL(this.quickBars[0].url)
      // Update the pathname with the dynamic licenseId
      url.pathname = `/licence/${licenseId}/v2/open_chat.cgi`
      // If there's a token, handle it
      if (this.$store.getters.token) {
        // Assuming handleTokenUrl is a function that adds the token to the URL
        url = new URL(handleTokenUrl(url.toString(), this.$store.getters.token))
      }
      // Update the quickBars array with the new URL
      this.quickBars[0].url = url.toString()
      this.$store.commit('SET_URLINFO_CSURL', this.quickBars[0].url)
    }
  }

}
</script>

<style>
.tips {
  height: 10px;
  width: 10px;
  background-color: #ce5555;
  display: block;
  top: 0px;
  right: 0px;
  z-index: 100000;
}
.modal-open .float_quick_block {
  right: 25px;
}
</style>
